module.exports = __webpack_public_path__ + "img/icon-coverage-purple.53dbefd5.svg";